var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelephonePurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25.1613,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67742
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18298_1836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7234 28.7292C31.8977 28.6133 32.0981 28.5427 32.3065 28.5237C32.5149 28.5048 32.7248 28.5381 32.917 28.6207L40.3333 31.9436C40.5833 32.0504 40.7919 32.2353 40.9279 32.4706C41.064 32.7059 41.1202 32.9789 41.0882 33.2488C40.8438 35.0747 39.9447 36.7496 38.558 37.9622C37.1713 39.1748 35.3913 39.8425 33.5492 39.8411C27.877 39.8411 22.4371 37.5878 18.4262 33.577C14.4154 29.5661 12.1621 24.1262 12.1621 18.454C12.1607 16.6119 12.8284 14.8319 14.041 13.4452C15.2536 12.0585 16.9285 11.1594 18.7544 10.915C19.0243 10.883 19.2973 10.9392 19.5326 11.0753C19.7679 11.2113 19.9528 11.4199 20.0596 11.6699L23.3825 19.0925C23.4641 19.2831 23.4974 19.491 23.4793 19.6976C23.4611 19.9042 23.3922 20.1031 23.2787 20.2766L19.9181 24.2725C19.7989 24.4524 19.7284 24.6601 19.7135 24.8754C19.6986 25.0907 19.7398 25.3062 19.8332 25.5007C21.1337 28.1631 23.8857 30.8821 26.5559 32.17C26.7515 32.2629 26.968 32.3033 27.1839 32.287C27.3998 32.2707 27.6078 32.1984 27.7873 32.0773L31.7234 28.7292Z",
    stroke: "#42296E",
    strokeWidth: 2.51613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18298_1836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.2581,
    height: 40.2581,
    fill: "white",
    transform: "translate(5.87109 5.87109)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephonePurple);
export default __webpack_public_path__ + "static/media/telephone-purple.8cd6c3998ad9744ab4eabb464820f92c.svg";
export { ForwardRef as ReactComponent };